/**
 * "Powered by CCMS" with the CCMS mark. Small and muted: the footer of every page. Never in the header.
 */
export function PoweredByCcms({ size = 'sm', className }: { size?: 'sm' | 'md'; className?: string }) {
  const px = size === 'md' ? 20 : 16;
  return (
    <span className={`proc-poweredby${size === 'md' ? ' md' : ''}${className ? ` ${className}` : ''}`}>
      Powered by <img src="/brand/ccms-mark.png" alt="" width={px} height={px} decoding="async" /> <b>CCMS</b>
    </span>
  );
}
